import { IFormValues, get, submitForm } from "lib/fetch";
import { IUploadRuleData } from "store/types";

export const GET_RULE = "rule/GET";
export const ADD_RULE = "rule/ADD";

export const getRule = (_format = "csv", version?: number | null) => ({
  type: GET_RULE,
  payload: version ? get(`/v1/rules?version=${version}`) : get(`/v1/rules`),
});

export const addRule = (files: File[], payload: IUploadRuleData) => {
  const { format, version, reportOnly } = payload;
  const fields: IFormValues = {};
  files.forEach((f) => {
    fields[f.name] = f;
  });

  return {
    type: ADD_RULE,
    payload: submitForm(`/v1/rules?format=${format}&version=${version}&reportOnly=${reportOnly}`, fields, {}, null),
  };
};
